import { APIFetchError } from "../lib/error";

export function rejectBad(request: Request, response: Response) {
  if (response.status >= 400) {
    throw new APIFetchError("Status Code", request, response);
  }
}
